import { CSSProperties } from 'react'
import css from './inlineSelect.module.css'
import cn from '../../cn'
import { IOption } from '../Dropdown'

const InlineSelect = <T extends string>(props: Props<T>) => {
  const disabledOptions = props.disabledOptions || []

  const handleClick = (e) => {
    const { value } = e.target.dataset

    if (!disabledOptions.includes(value)) {
      props.onChange(value, props.name)
    }
  }

  const buttons = props.options.map((o) => {
    const className = cn({
      [css.button]: true,
      [css.buttonActive]: o.value === props.value,
      [css.buttonDisabled]: disabledOptions.includes(o.value),
    })

    return (
      <div key={o.value} data-value={o.value} className={className} onClick={handleClick}>
        {o.title}
      </div>
    )
  })

  const size = props.size || 'normal'
  const className = cn({
    [css.wrapper]: true,
    [css.wrapperSmall]: size === 'small',
  })

  return (
    <div className={className} style={props.style}>
      {buttons}
    </div>
  )
}

interface Props<T extends string> {
  value: T
  options: IOption<T>[]
  disabledOptions?: string[]
  size?: 'normal' | 'small'
  style?: CSSProperties
  onChange: (value: T, name: string) => void
  name?: string
}

export default InlineSelect
